import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import DefaultImg from '../assets/loading/Default.jpg'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: DefaultImg,
  loading: DefaultImg,
  attempt: 1,
});
